import { Link } from "react-router-dom";
import { siteInfo } from "@/mocks/site";

export default function Footer() {
  const year = new Date().getFullYear();

  return (
    <footer className="bg-secondary-900 text-secondary-100 mt-16">
      <div className="w-full px-4 md:px-8 py-12 grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8">
        <div className="lg:col-span-2">
          <div className="flex items-center gap-2 mb-4">
            <span className="w-9 h-9 rounded-md bg-primary-500 text-background-50 flex items-center justify-center">
              <i className="ri-newspaper-line text-lg" />
            </span>
            <span className="text-lg font-black text-background-50">{siteInfo.name}</span>
          </div>
          <p className="text-sm text-secondary-200 leading-relaxed max-w-md">{siteInfo.description}</p>
          <p className="text-xs text-secondary-300 mt-4">
            本站全部内容均为演示用虚构信息，人物、事件与数据均非真实，仅供产品展示与体验。
          </p>
        </div>

        <div>
          <h4 className="text-sm font-bold text-background-50 mb-4">栏目导航</h4>
          <ul className="space-y-2.5">
            {siteInfo.friendLinks.map((link) => (
              <li key={link.name}>
                <Link
                  to={link.url}
                  className="text-sm text-secondary-200 hover:text-primary-300 transition-colors cursor-pointer"
                >
                  {link.name}
                </Link>
              </li>
            ))}
          </ul>
        </div>

        <div>
          <h4 className="text-sm font-bold text-background-50 mb-4">联系我们</h4>
          <ul className="space-y-3 text-sm text-secondary-200">
            <li className="flex items-start gap-2">
              <i className="ri-mail-line mt-0.5 text-primary-300" />
              <a href={`mailto:${siteInfo.email}`} className="hover:text-primary-300 cursor-pointer break-all">
                {siteInfo.email}
              </a>
            </li>
            <li className="flex items-start gap-2">
              <i className="ri-map-pin-line mt-0.5 text-primary-300" />
              <span className="leading-relaxed">{siteInfo.address}</span>
            </li>
          </ul>
          <div className="flex items-center gap-3 mt-5">
            {["ri-wechat-line", "ri-weibo-line", "ri-video-line", "ri-rss-line"].map((icon) => (
              <span
                key={icon}
                className="w-9 h-9 flex items-center justify-center rounded-md bg-secondary-800 text-secondary-200 cursor-pointer hover:bg-primary-500 hover:text-background-50 transition-colors"
              >
                <i className={`${icon} text-lg`} />
              </span>
            ))}
          </div>
        </div>
      </div>

      <div className="w-full px-4 md:px-8 py-5 border-t border-secondary-800 flex flex-col sm:flex-row items-center justify-between gap-2 text-xs text-secondary-300">
        <span>© {year} {siteInfo.name} · 演示站点 保留所有权利</span>
        <span>爆料有风险，吃瓜需理性 · 内容仅供演示</span>
      </div>
    </footer>
  );
}